import React, { useEffect, useState } from "react";
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import { withRouter } from "react-router-dom";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import PostAddIcon from "@material-ui/icons/PostAdd";
import AddBoxIcon from "@material-ui/icons/AddBox";
import WidgetsIcon from "@material-ui/icons/Widgets";
import ClassIcon from "@material-ui/icons/Class";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
// core components
import GridItem from "./components/Grid/GridItem.js";
import GridContainer from "./components/Grid/GridContainer.js";
import Card from "./components/Card/Card";
import CardHeader from "./components/Card/CardHeader.js";
import CardIcon from "./components/Card/CardIcon.js";
import CardFooter from "./components/Card/CardFooter.js";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle";
import { CircularProgress, Divider } from "@material-ui/core";
import { invokeApi } from "../../bl_libs/ApiCalling.js";
import LanguageIcon from "@material-ui/icons/Language";
import PaiChart from "./components/PaiChart/PaiChart.jsx";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
const useStyles = makeStyles(styles);

function Dashboard() {
  const classes = useStyles();

  const [stats, setStats] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const GetDashboardStates = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/dashboard",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = {};
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      if (res.code === 200) {
        setIsLoading(false);
        setStats(res.data);
      }
    });
  };

  const calculatePercentage = (requestType) => {
    if (requestType === "Active") {
      let result = (count_active_request_data / count_request_data) * 100;
      return result.toFixed(2) + " %";
    }

    if (requestType === "Completed") {
      let result = (count_completed_request_data / count_request_data) * 100;
      return result.toFixed(2) + " %";
    }

    if (requestType === "Cancelled") {
      let result = (count_cancelled_request_data / count_request_data) * 100;
      return result.toFixed(2) + " %";
    }

    return "Invalid requestType";
  };

  const getStatusForCustomer = (status) => {
    if (status === 0) {
      return "Awaiting Company Response";
    }
    if (status === 1) {
      return "Pending Acceptance";
    }
    if (status === 2) {
      return "Awaiting Payment";
    }
    if (status === 3) {
      return "Paid and waiting for move";
    }
    if (status === 4) {
      return "Truck assigned and ready to move";
    }
    if (status === 5) {
      return "Move in progress";
    }
    if (status === 6) {
      return "Completed, waiting for confirmation";
    }
    if (status === 7) {
      return "Completed";
    }
    if (status === 8) {
      return "Feedback Given";
    }
    //Bid cancell
    if (status === 11) {
      return "Request Cancelled";
    }
  };
  useEffect(() => {
    GetDashboardStates();
  }, []);

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const {
    count_customer_data,
    count_company_data,
    //
    count_request_data,
    count_request_workplace_data,
    count_request_crm_data,
    //
    count_active_request_data,
    count_cancelled_request_data,
    count_completed_request_data,
    count_foreman_data,
    count_item_data,
    count_extra_item_data,
    count_move_size_data,
    count_service_area_data,
    // acive by status
    count_active_request_timeline_eight_data,
    count_active_request_timeline_five_data,
    count_active_request_timeline_four_data,
    count_active_request_timeline_one_data,
    count_active_request_timeline_seven_data,
    count_active_request_timeline_six_data,
    count_active_request_timeline_three_data,
    count_active_request_timeline_two_data,
    count_active_request_timeline_zero_data,
    // cancell by status
    count_cancelled_request_timeline_eight_data,
    count_cancelled_request_timeline_five_data,
    count_cancelled_request_timeline_four_data,
    count_cancelled_request_timeline_one_data,
    count_cancelled_request_timeline_seven_data,
    count_cancelled_request_timeline_six_data,
    count_cancelled_request_timeline_three_data,
    count_cancelled_request_timeline_two_data,
    count_cancelled_request_timeline_zero_data,
    // completed
    count_completed_request_timeline_eight_data,
  } = stats;

  return (
    <div className="pb-40">
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Requests</p>
              <h3 className={classes.cardTitle}>{count_request_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Market Place Requests</p>
              <h3 className={classes.cardTitle}>
                {count_request_workplace_data}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>CRM Requests</p>
              <h3 className={classes.cardTitle}>{count_request_crm_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Active Requests</p>
              <h3 className={classes.cardTitle}>{count_active_request_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
              <span
                className={classes.stats}
                style={{ fontSize: 18, color: "#55b42d" }}
              >
                {calculatePercentage("Active")}
              </span>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Completed Requests</p>
              <h3 className={classes.cardTitle}>
                {count_completed_request_data}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
              <span
                className={classes.stats}
                style={{ fontSize: 18, color: "#22886e" }}
              >
                {calculatePercentage("Completed")}
              </span>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <PostAddIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Cancelled Requests</p>
              <h3 className={classes.cardTitle}>
                {count_cancelled_request_data}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
              <span
                className={classes.stats}
                style={{ fontSize: 18, color: "#e28495" }}
              >
                {calculatePercentage("Cancelled")}
              </span>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="primary">
                <LocationCityIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Companies</p>
              <h3 className={classes.cardTitle}>{count_company_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="primary">
                <PermContactCalendarIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Customers</p>
              <h3 className={classes.cardTitle}>{count_customer_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="primary">
                <EmojiPeopleIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Foremans</p>
              <h3 className={classes.cardTitle}>{count_foreman_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <LanguageIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Service Area</p>
              <h3 className={classes.cardTitle}>{count_service_area_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="primary">
                <WidgetsIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Items</p>
              <h3 className={classes.cardTitle}>{count_item_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="primary">
                <ClassIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Extra Items</p>
              <h3 className={classes.cardTitle}>{count_extra_item_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="primary">
                <EmojiTransportationIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Total Move Size</p>
              <h3 className={classes.cardTitle}>{count_move_size_data}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>Tracked from LA Moving Star</div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Divider />

      <div className="row mt-3 mb-3">
        <div className="col-12 col-xl-4 border-right">
          {/* <PaiChart data={allRequestData} /> */}
          <span className="dashboard-heading">Requests</span>
          <div className="pt-3">
            <DonutLargeIcon color="primary" />
            <span className="pl-2">Total Requests</span>
            <span className="float-right">{count_request_data}</span>
          </div>
          <div className="pt-3">
            <DonutLargeIcon color="primary" />
            <span className="pl-2">Total Market Place Requests</span>
            <span className="float-right">{count_request_workplace_data}</span>
          </div>
          <div className="pt-3">
            <DonutLargeIcon color="primary" />
            <span className="pl-2">Total CRM Requests</span>
            <span className="float-right">{count_request_crm_data}</span>
          </div>
          <div className="pt-3 row">
            <div className="col-6">
              <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
              <span className="pl-2">Active Requests</span>
            </div>
            <div className="col-3 text-right">
              {calculatePercentage("Active")}
            </div>
            <div className="col-3 text-right">{count_active_request_data}</div>
          </div>

          <div className="pt-3 row">
            <div className="col-6">
              <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
              <span className="pl-2">Cancelled Requests</span>
            </div>
            <div className="col-3 text-right">
              {calculatePercentage("Cancelled")}
            </div>
            <div className="col-3 text-right">
              {count_cancelled_request_data}
            </div>
          </div>

          <div className="pt-3 row">
            <div className="col-6">
              <CheckCircleOutlineIcon style={{ color: "rgb(34, 136, 110)" }} />
              <span className="pl-2">Completed Requests</span>
            </div>
            <div className="col-3 text-right">
              {calculatePercentage("Completed")}
            </div>
            <div className="col-3 text-right">
              {count_completed_request_data}
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-8">
          <span className="dashboard-heading"> Requests Timeline</span>
          <div className="row">
            {/* left half */}
            <div className="col-12 col-xl-6">
              {/* 0 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(0)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_zero_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_zero_data}
                  </span>
                </div>
              </div>
              {/* 1 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(1)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_one_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_one_data}
                  </span>
                </div>
              </div>
              {/* 2 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(2)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_two_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_two_data}
                  </span>
                </div>
              </div>
              {/* 3 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(3)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_three_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_three_data}
                  </span>
                </div>
              </div>
            </div>
            {/* right half */}
            <div className="col-12 col-xl-6">
              {/* 4 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(4)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_four_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_four_data}
                  </span>
                </div>
              </div>

              {/* 5 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(5)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_five_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_five_data}
                  </span>
                </div>
              </div>
              {/* 6 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(6)}</span>
                </div>
                <div className="col-2 ">
                  <RotateRightIcon style={{ color: "rgb(85, 180, 45)" }} />
                  <span className="pl-2">
                    {count_active_request_timeline_six_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_six_data}
                  </span>
                </div>
              </div>
              {/* 7 */}
              <div className="pt-3 row">
                <div className="col-8">
                  <FiberManualRecordIcon color="primary" />
                  <span className="pl-2">{getStatusForCustomer(7)}</span>
                </div>
                <div className="col-2 ">
                  <CheckCircleOutlineIcon
                    style={{ color: "rgb(34, 136, 110)" }}
                  />
                  <span className="pl-2">
                    {count_completed_request_timeline_eight_data}
                  </span>
                </div>
                <div className="col-2 ">
                  <HighlightOffIcon style={{ color: "rgb(226, 132, 149)" }} />
                  <span className="pl-2">
                    {count_cancelled_request_timeline_seven_data}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider />
    </div>
  );
}
export default withRouter(Dashboard);
